import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
// Style order matters: tokens, base, then the mob component CSS (pulled in by
// the component modules that ./routes imports), then the shim, then DineOps.
import './styles/tokens.css';
import './styles/base.css';
import { router } from './routes';
import './styles/wtr-shim.css';
import './styles/dineops-mob.css';
import { SessionProvider } from './auth/SessionProvider';
import { ToastProvider } from './components/shared/Toast';
import { initServiceWorker } from './pwa/registerSW';
import { UpdatePrompt } from './pwa/UpdatePrompt';

initServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ToastProvider>
          <RouterProvider router={router} />
          {/* At the root, not in AppShell: a device parked on the login screen
              must still see "New version available", or a stale bundle can
              never be replaced (UAT, 2026-10-03). */}
          <UpdatePrompt />
        </ToastProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
